import { Scenario } from '../types';

export const scenarios: Scenario[] = [
  {
    id: 'eval-1',
    titre: 'Douleurs abdominales',
    niveau: 'Débutant',
    type: 'Médical',
    duree: 8,
    participants: 2,
    description: 'Une personne se plaint de douleurs abdominales progressives depuis ce matin.',
    historique: 'Marie Tremblay, pharmacienne de 43 ans, est au travail depuis 7h ce matin. Elle n\'a pas pris le temps de déjeuner à cause d\'une livraison importante de médicaments à gérer. Vers 10h, elle commence à ressentir des douleurs abdominales qui s\'intensifient progressivement. Elle prend habituellement du Sumatriptan pour ses migraines, mais n\'en a pas pris aujourd\'hui. Elle a mangé un sandwich à la cafétéria hier soir avant de partir, qui lui avait semblé avoir un goût étrange.',
    objectifs: [
      'Effectuer une évaluation secondaire complète',
      'Utiliser le SAMPLE',
      'Documenter les informations recueillies',
      'Déterminer la gravité de la situation'
    ],
    materiel: [
      'Fiche d\'évaluation',
      'Gants',
      'Montre avec trotteuse'
    ],
    deroulement: [
      'Obtention du consentement',
      'Questionnement selon SAMPLE',
      'Évaluation des signes vitaux',
      'Documentation des informations'
    ],
    evaluation: [
      'Approche structurée',
      'Questions pertinentes',
      'Documentation complète',
      'Évaluation de la gravité'
    ]
  },
  {
    id: 'eval-2',
    titre: 'Maux de tête sévères',
    niveau: 'Débutant',
    type: 'Médical',
    duree: 7,
    participants: 2,
    description: 'Un collègue se plaint de maux de tête intenses apparus subitement.',
    historique: 'Sylvie Gauthier, enseignante de 51 ans, termine une journée particulièrement stressante avec sa classe de 6e année. Elle a passé plusieurs heures à corriger des examens sur son ordinateur dans une salle mal éclairée. Vers 15h30, elle ressent soudainement un mal de tête intense, accompagné de sensibilité à la lumière. Elle est asthmatique et utilise occasionnellement son Ventolin, mais n\'a pas eu besoin de l\'utiliser aujourd\'hui. Elle n\'a pas pris son déjeuner et n\'a bu que deux cafés depuis ce matin.',
    objectifs: [
      'Évaluer la gravité des symptômes',
      'Identifier les signes d\'urgence',
      'Appliquer le protocole approprié'
    ],
    materiel: ['Fiche SAMPLE', 'Gants'],
    deroulement: [
      'Évaluation initiale',
      'Questionnaire SAMPLE',
      'Vérification des signes vitaux'
    ],
    evaluation: [
      'Rapidité d\'intervention',
      'Précision des questions',
      'Pertinence des actions'
    ]
  },
  {
    id: 'eval-3',
    titre: 'Étourdissements',
    niveau: 'Débutant',
    type: 'Médical',
    duree: 6,
    participants: 2,
    description: 'Une personne ressent des vertiges en se levant de son bureau.',
    historique: 'Michel Fortin, chauffeur d\'autobus de 58 ans, termine sa pause déjeuner au bureau de répartition. Il est diabétique et prend de la Metformine 1000mg. Aujourd\'hui, pris par le temps, il n\'a pas bien mangé et a sauté sa collation habituelle. En se levant rapidement de sa chaise pour reprendre son service, il est pris de vertiges. Il transpire abondamment et ses mains tremblent légèrement. Son dernier repas remonte à plus de 6 heures.',
    objectifs: [
      'Évaluer les risques de chute',
      'Identifier les causes possibles',
      'Appliquer les mesures de sécurité'
    ],
    materiel: ['Chaise', 'Fiche d\'évaluation'],
    deroulement: [
      'Sécurisation de l\'environnement',
      'Évaluation des symptômes',
      'Application des premiers soins'
    ],
    evaluation: [
      'Sécurité assurée',
      'Évaluation complète',
      'Actions appropriées'
    ]
  },
  {
    id: 'eval-4',
    titre: 'Réaction allergique légère',
    niveau: 'Débutant',
    type: 'Médical',
    duree: 8,
    participants: 2,
    description: 'Un employé développe une éruption cutanée après avoir mangé.',
    historique: 'Julie Deschamps, professeure de yoga de 35 ans, mange son lunch dans la salle de repos du studio. Elle essaie une nouvelle salade préparée qu\'elle a achetée dans un nouveau restaurant. Elle est allergique au gluten mais a fait attention à commander sans gluten. Après quelques bouchées, elle remarque des démangeaisons et une éruption cutanée qui commence à apparaître sur ses avant-bras. Elle n\'a jamais eu de réaction allergique grave auparavant, mais s\'inquiète car les symptômes semblent progresser rapidement.',
    materiel: ['Gants', 'Fiche de suivi'],
    deroulement: [
      'Observation des symptômes',
      'Documentation de l\'incident',
      'Surveillance continue'
    ],
    evaluation: [
      'Observation détaillée',
      'Documentation précise',
      'Suivi approprié'
    ]
  },
  {
    id: 'eval-5',
    titre: 'Fatigue extrême',
    niveau: 'Débutant',
    type: 'Médical',
    duree: 5,
    participants: 2,
    description: 'Un travailleur montre des signes d\'épuisement pendant sa journée.',
    historique: 'Hugo Pelletier, journaliste de 42 ans, travaille sur un article important depuis 72 heures avec très peu de sommeil. Il souffre d\'insomnie chronique et prend du Zopiclone 5mg, mais a sauté plusieurs doses pour tenir ses délais. En pleine réunion éditoriale, il montre des signes évidents de fatigue extrême : difficultés de concentration, tremblements légers et confusion dans ses propos. Ses collègues remarquent qu\'il a du mal à garder les yeux ouverts et qu\'il transpire anormalement.',
    materiel: ['Fiche d\'évaluation'],
    deroulement: [
      'Évaluation de l\'état',
      'Questionnaire ciblé',
      'Recommandations'
    ],
    evaluation: [
      'Évaluation complète',
      'Pertinence des questions',
      'Recommandations adaptées'
    ]
  },
  // Les autres scénarios sont déjà complets avec leurs historiques
  {
    id: 'eval-16',
    titre: 'Hyperventilation',
    niveau: 'Intermédiaire',
    type: 'Médical',
    duree: 8,
    participants: 2,
    description: 'Une personne présente une respiration rapide et de l\'anxiété.',
    historique: 'Mélanie Girard, chef d\'entreprise de 44 ans, prépare une présentation cruciale pour des investisseurs. Elle souffre de stress chronique et prend des anxiolytiques au besoin. Juste avant sa présentation, elle apprend qu\'un contrat majeur risque d\'être perdu. Dans la salle de conférence, elle commence à ressentir des picotements dans les mains, sa respiration s\'accélère et elle a l\'impression de manquer d\'air. Elle n\'a pas pris son anxiolytique aujourd\'hui, pensant pouvoir gérer son stress.',
    materiel: ['Espace calme', 'Chaise'],
    deroulement: [
      'Installation calme',
      'Exercices de respiration',
      'Évaluation'
    ],
    evaluation: [
      'Approche rassurante',
      'Techniques efficaces',
      'Suivi approprié'
    ]
  },
  {
    id: 'eval-17',
    titre: 'Déshydratation',
    niveau: 'Débutant',
    type: 'Médical',
    duree: 7,
    participants: 2,
    description: 'Un travailleur montre des signes de déshydratation.',
    historique: 'Kevin Martin, mécanicien de 24 ans, travaille depuis le matin dans un garage non climatisé pendant une vague de chaleur. Passionné par son travail, il a négligé de boire suffisamment d\'eau, se contentant de quelques gorgées de café. Vers 14h, il commence à ressentir des vertiges, a la bouche très sèche et remarque que sa peau est chaude et sèche au toucher. Il n\'a pas uriné depuis le début de son quart de travail et se sent inhabituellement fatigué.',
    materiel: ['Eau', 'Fiche d\'évaluation'],
    deroulement: [
      'Évaluation des signes',
      'Réhydratation progressive',
      'Surveillance'
    ],
    evaluation: [
      'Reconnaissance des signes',
      'Mesures appropriées',
      'Suivi adéquat'
    ]
  },
  {
    id: 'eval-18',
    titre: 'Migraine sévère',
    niveau: 'Débutant',
    type: 'Médical',
    duree: 6,
    participants: 2,
    description: 'Une employée souffre d\'une migraine intense.',
    historique: 'Sarah Lambert, graphiste de 29 ans, travaille sur un projet urgent depuis plusieurs heures sans pause. Elle souffre occasionnellement de migraines et prend de l\'Ibuprofène 400mg au besoin. Après avoir passé la matinée à fixer son écran dans un bureau fortement éclairé, elle développe une migraine intense avec sensibilité à la lumière et nausées. Elle a déjà pris sa dose maximale d\'Ibuprofène pour la journée et les symptômes continuent de s\'aggraver.',
    materiel: ['Fiche SAMPLE', 'Espace calme'],
    deroulement: [
      'Isolation au calme',
      'Évaluation des symptômes',
      'Mesures de confort'
    ],
    evaluation: [
      'Environnement adapté',
      'Évaluation complète',
      'Mesures appropriées'
    ]
  },
  {
    id: 'eval-19',
    titre: 'Douleur thoracique',
    niveau: 'Avancé',
    type: 'Médical',
    duree: 10,
    participants: 3,
    description: 'Un employé ressent une douleur à la poitrine.',
    historique: 'Robert Simard, retraité de 72 ans, participe à une activité communautaire. Il souffre d\'hypertension contrôlée par Amlodipine 5mg et d\'arthrite traitée par Naproxène. Après avoir monté deux étages d\'escaliers pour rejoindre une réunion, il ressent une douleur oppressante à la poitrine qui irradie dans son bras gauche. Il est en sueur, essoufflé et se sent anxieux. Il a des antécédents familiaux de maladies cardiaques mais n\'a jamais eu de problèmes cardiaques personnels.',
    materiel: ['DEA', 'Téléphone', 'Fiche'],
    deroulement: [
      'Évaluation rapide',
      'Position confortable',
      'Surveillance continue'
    ],
    evaluation: [
      'Évaluation précise',
      'Actions appropriées',
      'Communication efficace'
    ]
  },
  {
    id: 'eval-20',
    titre: 'Malaise vagal',
    niveau: 'Intermédiaire',
    type: 'Médical',
    duree: 8,
    participants: 2,
    description: 'Une personne fait un malaise pendant une réunion.',
    historique: 'Nathalie Morin, vétérinaire de 39 ans, assiste à une longue réunion dans une salle surchauffée. Elle n\'a pas déjeuné ce matin à cause d\'une urgence à la clinique et prend de la Cétirizine pour son allergie aux chats. Pendant la présentation, elle commence à se sentir étourdie, a des sueurs froides et sa vision devient floue. Elle a déjà eu un épisode similaire l\'année dernière lors d\'une prise de sang.',
    materiel: ['Chaise', 'Fiche d\'évaluation'],
    deroulement: [
      'Position adaptée',
      'Évaluation des signes',
      'Surveillance'
    ],
    evaluation: [
      'Réaction rapide',
      'Position correcte',
      'Surveillance adéquate'
    ]
  },
  {
    id: 'eval-21',
    titre: 'Hypothermie légère',
    niveau: 'Intermédiaire',
    type: 'Médical',
    duree: 10,
    participants: 2,
    description: 'Un travailleur présente des signes d\'hypothermie après avoir travaillé dehors.',
    historique: 'Antoine Lavoie, étudiant en kinésiologie de 21 ans, supervise une activité sportive extérieure par temps pluvieux et froid. Malgré la météo, il n\'a pas mis de vêtements imperméables adéquats. Après deux heures d\'exposition à la pluie et au vent, il commence à frissonner de manière incontrôlable, ses lèvres deviennent légèrement bleues et il a du mal à articuler clairement. Il est allergique aux fruits de mer mais n\'a pas d\'autres problèmes de santé connus.',
    materiel: ['Couvertures', 'Thermomètre', 'Fiche'],
    deroulement: [
      'Évaluation initiale',
      'Réchauffement progressif',
      'Surveillance continue'
    ],
    evaluation: [
      'Évaluation précise',
      'Mesures appropriées',
      'Suivi régulier'
    ]
  }
];